export const memberLoadingAction = status => ({
  type: 'MEMBER_LOADING',
  status,
})

export const myMemberLoadingAction = status => ({
  type: 'MY_MEMBER_LOADING',
  status,
})
